import { CacheInfo, CacheType } from '../types';
import { getCookie, safeJsonParse } from './utils';

const IWAN_LOGIN_CACHE_PREFIX = 'iwan_login_cache';

/**
 * 头像昵称缓存装饰器
 */
export function cache(type: CacheType) {
  return (target: Object, fnName: string, _fnDescriptor: PropertyDescriptor): PropertyDescriptor => {
    const fnDescriptor = _fnDescriptor;
    const fn = fnDescriptor.value;

    fnDescriptor.value = async function (...args: any[]) {
      const openId = getCookie('yyb_openid')
        || getCookie('vqq_openid')
        || getCookie('openid')
        || getCookie('mobileqopenid');
      const key = `${IWAN_LOGIN_CACHE_PREFIX}_${type}_${openId}`;

      // 允许外部设置是否禁用缓存
      // @ts-ignore
      const { isDisableCache = false } = this;

      if (!isDisableCache) {
        // 读取缓存
        const cacheInfo = safeJsonParse<CacheInfo>(localStorage.getItem(key) || '');
        if (cacheInfo) {
          const { data, expire } = cacheInfo;
          const now = Date.now();
          // 是否过期
          if (now > expire) {
            localStorage.removeItem(key);
          } else {
            return data;
          }
        }
      }

      const result = await fn.apply(this, args);

      // 写缓存
      if (result.errCode === 0 && !isDisableCache) {
        localStorage.setItem(key, JSON.stringify({
          data: result,
          expire: Date.now() + 14 * 86400 * 1000, // 14day
        }));
      }

      return result;
    };
    return fnDescriptor;
  };
}
